import { type QAjaxBarProps } from 'quasar';

export const AJAX_LOADING_BAR_PROPS: QAjaxBarProps = {
    color: 'primary',
    size: '6px',
    position: 'top'
};
